var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-item",
      class: {
        selected: _vm.isSelected(_vm.item),
        "is-private": _vm.item.isPrivate,
      },
      attrs: { "data-menukey": _vm.item.dataKey },
      on: {
        click: function ($event) {
          return _vm.fnCallback(_vm.item)
        },
        touchend: function ($event) {
          $event.preventDefault()
          return _vm.handleTouchEnd.apply(null, arguments)
        },
        dblclick: _vm.handleDoubleClick,
        contextmenu: _vm.handleContextMenu,
        mouseover: function ($event) {
          _vm.hoverActive = true
        },
        mouseleave: function ($event) {
          _vm.hoverActive = false
        },
        touchstart: _vm.handleTouchStart,
        touchcancel: _vm.handleTouchCancel,
      },
    },
    [
      _vm.item.icon.type === "material-icons"
        ? [
            _c("div", { staticClass: "sidebar-menu-item-icon" }, [
              _c("div", { staticClass: "material-icons" }, [
                _vm._v(_vm._s(_vm.item.icon.name)),
              ]),
              _vm._v(" "),
              _vm.item.isPrivate
                ? _c("div", { staticClass: "private-indicator" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("lock"),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.item.icon.type === "chatbot"
        ? [
            _c("div", { staticClass: "sidebar-menu-item-icon" }, [
              _c("div", { staticClass: "material-icons" }, [_c("Chatbot")], 1),
            ]),
          ]
        : _vm.item.icon.type === "component"
        ? [
            _c(
              "div",
              { staticClass: "sidebar-menu-item-icon" },
              [
                _c(_vm.item.icon.name, {
                  tag: "component",
                  class: _vm.item.icon.class,
                  style: _vm.item.icon.style,
                  attrs: { id: "component-icon" },
                }),
                _vm._v(" "),
                _vm.item.isPrivate
                  ? _c("div", { staticClass: "private-indicator" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("lock"),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-menu-item-content" }, [
        _c(
          "div",
          {
            staticClass: "sidebar-menu-item-text",
            attrs: { title: _vm.item.label },
          },
          [_vm._v("\n            " + _vm._s(_vm.item.label) + "\n        ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "action-container" }, [
          _vm.item.badge && !(_vm.showSearchButton && _vm.hoverActive)
            ? _c("div", { staticClass: "sidebar-menu-item-badge" })
            : _vm.item.counter > 0 && !(_vm.showSearchButton && _vm.hoverActive)
            ? _c("div", { staticClass: "sidebar-menu-item-count" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.getCounter()) +
                    "\n            "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showSearchButton && _vm.hoverActive
            ? _c(
                "div",
                {
                  staticClass: "search-icon-overlay",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleSearch.apply(null, arguments)
                    },
                  },
                },
                [_c("i", { staticClass: "material-icons" }, [_vm._v("search")])]
              )
            : _vm._e(),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }